"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fromMetadata;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _util = require("@plugnet/util");

var _createUnchecked = _interopRequireDefault(require("./utils/createUnchecked"));

var _ = _interopRequireDefault(require("."));

// Copyright 2017-2019 @polkadot/extrinsics authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * Extend a storage object with the storage modules & module functions present
 * in the metadata.
 *
 * @param extrinsics - An extrinsics object to be extended.
 * @param metadata - The metadata to extend the storage object against.
 */
function fromMetadata(metadata) {
  let indexCount = -1;

  const findIndex = prefix => {
    indexCount++;
    const mod = metadata.calls.find(item => item.prefix.toString() === prefix);

    if (!mod) {
      console.error("Unable to find module index for '".concat(prefix, "'")); // compatible with old versions

      return indexCount;
    }

    return mod.index.toNumber();
  };

  return metadata.modules.reduce((result, meta) => {
    if (!meta.module.call || !meta.module.call.functions.length) {
      return result;
    }

    const prefix = (0, _util.stringCamelCase)(meta.prefix.toString());
    const index = findIndex(meta.prefix.toString());
    result[prefix] = meta.module.call.functions.reduce((newModule, funcMeta) => {
      // extrinsics.balances.set_balance -> extrinsics.balances.setBalance
      const funcName = (0, _util.stringCamelCase)(funcMeta.name.toString());
      newModule[funcName] = (0, _createUnchecked.default)(prefix, funcName, index, funcMeta);
      return newModule;
    }, {});
    return result;
  }, (0, _objectSpread2.default)({}, _.default));
}